import { useEffect } from "react";

const SITE_URL = "https://anderstongroup.co.uk";
const defaults = {};

const selectors = {
  description: 'meta[name="description"]',
  canonical: 'link[rel="canonical"]',
  ogTitle: 'meta[property="og:title"]',
  ogDescription: 'meta[property="og:description"]',
  ogUrl: 'meta[property="og:url"]',
  ogImage: 'meta[property="og:image"]',
  ogType: 'meta[property="og:type"]',
  twTitle: 'meta[name="twitter:title"]',
  twDescription: 'meta[name="twitter:description"]',
  twImage: 'meta[name="twitter:image"]',
};

const read = (sel) => {
  const el = document.head.querySelector(sel);
  if (!el) return null;
  return el.tagName === "LINK" ? el.getAttribute("href") : el.getAttribute("content");
};

const write = (sel, value) => {
  if (value == null) return;
  const el = document.head.querySelector(sel);
  if (!el) return;
  if (el.tagName === "LINK") el.setAttribute("href", value);
  else el.setAttribute("content", value);
};

/**
 * Per-route SEO: title, description, canonical, Open Graph / Twitter, JSON-LD.
 * Restores the index.html defaults on unmount.
 */
export function useSeo({ title, description, path, image, type = "website", jsonLd }) {
  useEffect(() => {
    if (!defaults.title) {
      defaults.title = document.title;
      Object.entries(selectors).forEach(([k, sel]) => (defaults[k] = read(sel)));
    }
    if (!title) return undefined;

    const url = `${SITE_URL}${path || "/"}`;
    const absImage = image && image.startsWith("/") ? `${SITE_URL}${image}` : image;
    document.title = title;
    write(selectors.description, description);
    write(selectors.canonical, url);
    write(selectors.ogTitle, title);
    write(selectors.ogDescription, description);
    write(selectors.ogUrl, url);
    write(selectors.ogImage, absImage);
    write(selectors.ogType, type);
    write(selectors.twTitle, title);
    write(selectors.twDescription, description);
    write(selectors.twImage, absImage);

    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "page-jsonld";
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }

    return () => {
      document.title = defaults.title;
      Object.entries(selectors).forEach(([k, sel]) => write(sel, defaults[k]));
      script?.remove();
    };
  }, [title, description, path, image, type, jsonLd]);
}
